<template>
  <div v-if="purchaseOrders && stylesLoaded" class="w-full">
    <div class="po-header">
      <h3 class="page-header-2">Purchase Orders</h3>
      <div class="add-order-button">
        <Button @click="toggleOrderModal(null)">
          <i class="fa fa-plus"></i>
          Add Purchase Order
        </Button>
      </div>
    </div>
    <div class="mt-4 datatable-report w-full">
      <Table data-cy="purchase-order-table" class="!mx-0">
        <thead>
          <tr>
            <th>PO Number</th>
            <th>Created Date</th>
            <th>Category</th>
            <th>For</th>
            <th>Vendor</th>
            <th width="50%">Description</th>
            <th class="text-right">Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="po in purchaseOrders"
            :key="po.purchase_order_id"
            :class="{ void: po.void }"
          >
            <td>
              <div class="link" @click="toggleOrderModal(po)">
                {{ po.po_number }}
              </div>
            </td>
            <td>{{ shortDate(po.po_date) }}</td>
            <td>{{ po.po_type }}</td>
            <td>{{ po.created_for ? po.created_for.full_name : "--" }}</td>
            <td>{{ po.vendor }}</td>
            <td class="description-field">
              {{ po.description }}
            </td>
            <td class="text-right">{{ dollars(po.amount_cents) }}</td>
          </tr>
          <tr v-if="!purchaseOrders.length">
            <td colspan="7" class="text-center">No Purchase Orders</td>
          </tr>
        </tbody>
      </Table>
    </div>
    <PurchaseOrderModal
      v-if="purchaseOrderModal"
      :purchase-order="selectedPO"
      @hide-modal="toggleOrderModal(null)"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";

import Button from "@/components/Button.vue";
import Table from "@/components/Table.vue";
import PurchaseOrderModal from "../PurchaseOrderModal.vue";

export default {
  components: {
    Table,
    Button,
    PurchaseOrderModal
  },
  data() {
    return {
      purchaseOrderModal: false,
      selectedPO: null,
      stylesLoaded: false
    };
  },
  async created() {
    await import("../../components/datatable_tailwind.css");
    this.stylesLoaded = true;
  },
  computed: {
    ...mapState({
      purchaseOrders: ({ job }) => job.purchase_orders
    })
  },
  watch: {
    purchaseOrderModal(newValue, oldValue) {
      if (newValue !== oldValue && !newValue) {
        // Reset selected PO when closing modal
        this.selectedPO = null;
      }
    }
  },
  methods: {
    toggleOrderModal(po) {
      if (po) {
        this.selectedPO = po;
      }
      this.purchaseOrderModal = !this.purchaseOrderModal;
    }
  }
};
</script>

<style lang="scss" scoped>
.add-order-button {
  display: flex;
  justify-content: flex-end;
}
tr.void {
  text-decoration: line-through;
  font-style: italic;
  color: var(--gray) !important;
}

td.description-field {
  white-space: normal;
}

.po-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
